import { formatCaseDetails as _ } from '../../../../brand/features_public/cases/api/formatCase';

export const formatCaseDetails = _;
